'use client';

// @spec authentication-reauth

import { useUrlErrorParam } from '@client/hooks/use-url-error-param';
import { signIn, signOut } from 'next-auth/react';
import { useEffect, useRef } from 'react';

import { UrlErrorBanner } from './url-error-banner';

/**
 * Displays a user-friendly message when the signIn callback blocks a stale
 * re-link attempt (?error=SessionCleared). Reads the URL param, signs out,
 * and cleans the URL.
 *
 * Mounted in the root layout (outside AuthenticatedLayout) so it renders
 * even when the session is missing.
 */
export function SessionClearedError() {
  const show = useUrlErrorParam('SessionCleared');
  const signedOut = useRef(false);

  useEffect(() => {
    if (!show || signedOut.current) return;
    signedOut.current = true;
    // Server-side session cleanup (async, best-effort)
    void signOut({ redirect: false });
  }, [show]);

  if (!show) return null;

  return (
    <UrlErrorBanner
      message="Your previous session expired. Please sign in again."
      actionLabel="Sign In"
      onAction={() => void signIn('google')}
    />
  );
}
